import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Toast from "@cp/Toast.vue";

import { computed } from "vue";
import { useRouter } from "vue-router";
import { watch } from "vue";
import { restoreRootFontSize } from "@/libs/utils";
// const store = useStore()
// const loginPage = computed(() => store.loginPage)

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

_useCssVars(_ctx => ({
  "7c23f935": (_unref(loginPage))
}))

let loginPage = computed(() => "none");
const router = useRouter();
watch(
  () => router.currentRoute.value.path,
  (newValue, oldValue) => {
    if (newValue === "/login") {
      loginPage = computed(() => "initial");
    }
    if (oldValue === "/login") {
      loginPage = computed(() => "none");
      window.addEventListener("resize", () => {
        restoreRootFontSize();
      });
    }
  },
  {
    immediate: true,
  }
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(Toast)
  ], 64))
}
}

})